var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF1ModeAbsenceLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72 9V7.61a5.498 5.498 0 00-7.568-5.137A5.5 5.5 0 0061 7.53V9h-2v12h15V9h-2zm-4 9h-3v-6h3v6zm1-9h-5V7.53a2.48 2.48 0 011-2 2.56 2.56 0 012.32-.35A2.52 2.52 0 0169 7.61V9zM44.5 20.74L61 34.17v21.75H28V49c.166.01.334.01.5 0 2.31 0 4.5-1.77 4.5-4V33a5.55 5.55 0 00-1.43-3.2l12.93-9.06zM18.88 27a3 3 0 114.55 0c-.097.125-.208.24-.33.34a3 3 0 01-4.2-.34h-.02zm9.62 19a1.5 1.5 0 01-1.5-1.5V34a1.08 1.08 0 00-1-1h-1v27.5a1.5 1.5 0 11-3 0V48h-2v12.5a1.5 1.5 0 11-3 0V33h-1a1 1 0 00-1 1v10.5a1.5 1.5 0 11-3 0V34a4 4 0 014-4h10a4 4 0 014 4v10.5a1.5 1.5 0 01-1.5 1.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/F1_Mode_absence_locked.2e4e3220.svg";
export { SvgF1ModeAbsenceLocked as ReactComponent };